import React, { useEffect, useState } from "react";
import { Select, message } from "antd";
import grupoSeguroService from "services/GrupoSeguroService";
import usuarioService from "services/UsuarioService";
import { GlobalOutlined } from "@ant-design/icons";
import requestCacheService from "services/RequestCacheService";
import { customFilterOption } from "utils/FilterUtil";
/**
 * Componente para seleção de grupos seguros
 */
const GrupoSeguroSelector = () => {
	const [listaGrupoSeguro, setListaGrupoSeguro] = useState([]);
	const [loading, setLoading] = useState(true);
	const [atualizando, setAtualizando] = useState(false);
	const [grupoSelecionado, setGrupoSelecionado] = useState(null);
	const [dadosUsuario, setDadosUsuario] = useState(null);

	useEffect(() => {
		const carregarDados = async () => {
			try {
				setLoading(true);

				// Primeiro carregar dados do usuário para obter o grupo atual
				const usuario = await usuarioService.obterPropriosDados();
				setDadosUsuario(usuario);

				// Depois carregar grupos de rateio
				const grupos = await grupoSeguroService.getAll();
				setListaGrupoSeguro(grupos);

				// Definir o grupo selecionado com base no id_grupo_seguro do usuário
				if (usuario.id_grupo_seguro) {
					setGrupoSelecionado(usuario.id_grupo_seguro);
					// Verificar se o grupo existe na lista
					const grupoExiste = grupos.some(
						(grupo) => grupo.id === usuario.id_grupo_seguro,
					);
					if (!grupoExiste) {
						console.warn(
							"Grupo de rateio do usuário não encontrado na lista de grupos disponíveis",
						);
					}
				}
			} catch (error) {
				console.error("Erro ao carregar dados:", error);
				message.error(
					"Erro ao carregar dados. Tente novamente mais tarde.",
				);
			} finally {
				setLoading(false);
			}
		};

		carregarDados();
	}, []);

	const handleChange = async (value) => {
		if (value === grupoSelecionado) return;

		try {
			setAtualizando(true);

			// Atualizar o usuário com o id_grupo_seguro
			await usuarioService.put(
				{
					id_grupo_seguro: value,
				},
				dadosUsuario.id,
			);

			setGrupoSelecionado(value);
			message.success("Grupo de rateio atualizado com sucesso!");
			// Recarregar a página para atualizar os dados e limpar o cache
			window.location.reload(true);
			requestCacheService.limparCache();
		} catch (error) {
			console.error(
				"Erro ao atualizar grupo de rateio do usuário:",
				error,
			);
			message.error(
				"Erro ao atualizar grupo de rateio. Tente novamente.",
			);
		} finally {
			setAtualizando(false);
		}
	};

	return (
		<div className="grupo-seguro-selector">
			<Select
				loading={loading || atualizando}
				placeholder="Selecionar grupo"
				style={{ width: 200 }}
				onChange={handleChange}
				value={grupoSelecionado}
				showSearch
				filterOption={customFilterOption}
				dropdownMatchSelectWidth={false}
				suffixIcon={<GlobalOutlined />}
			>
				{listaGrupoSeguro?.map((item) => (
					<Select.Option key={item.id} value={item.id}>
						{item.nome}
					</Select.Option>
				))}
			</Select>
		</div>
	);
};

export default GrupoSeguroSelector;
